// extracted by mini-css-extract-plugin
export default {"language_block":"app-language_language_block__iju6H","language_dropdown":"app-language_language_dropdown__hWUkO"};